export const translations = {
    en: {
      step: "Step",
      of: "of",
      createAccount: "Create your account",
      emailAddress: "Email address",
      password: "Password",
      websiteUrl: "Website URL",
      companyName: "Company name",
      continue: "Continue",
      configureAI: "Configure AI Assistant",
      assistantTone: "Assistant's Tone",
      tones: {
        professional: "Professional",
        friendly: "Friendly",
        casual: "Casual"
      },
      primaryLanguage: "Primary Language",
      languages: {
        en: "English",
        de: "German",
        fr: "French",
        bg: "Bulgarian",
        ro: "Romanian"
      },
      knowledgeBase: "Knowledge Base",
      knowledgeBaseOptions: {
        auto: "Auto-generate from website",
        custom: "Upload custom documents",
        hybrid: "Hybrid (Auto + Custom)"
      },
      customizeAppearance: "Customize Appearance",
      primaryColor: "Primary Color",
      widgetPosition: "Widget Position",
      positions: {
        bottomRight: "Bottom Right",
        bottomLeft: "Bottom Left",
        topRight: "Top Right",
        topLeft: "Top Left"
      },
      theme: "Theme",
      themes: {
        light: "Light",
        dark: "Dark",
        system: "System Default"
      },
      completeSetup: "Complete Setup"
    },
    de: {
      step: "Schritt",
      of: "von",
      createAccount: "Konto erstellen",
      emailAddress: "E-Mail-Adresse",
      password: "Passwort",
      websiteUrl: "Website-URL",
      companyName: "Firmenname",
      continue: "Weiter",
      configureAI: "KI-Assistent konfigurieren",
      assistantTone: "Ton des Assistenten",
      tones: {
        professional: "Professionell",
        friendly: "Freundlich",
        casual: "Leger"
      },
      primaryLanguage: "Primäre Sprache",
      languages: {
        en: "Englisch",
        de: "Deutsch",
        fr: "Französisch",
        bg: "Bulgarisch",
        ro: "Rumänisch"
      },
      knowledgeBase: "Wissensbasis",
      knowledgeBaseOptions: {
        auto: "Automatisch von Website generieren",
        custom: "Benutzerdefinierte Dokumente hochladen",
        hybrid: "Hybrid (Auto + Benutzerdefiniert)"
      },
      customizeAppearance: "Erscheinungsbild anpassen",
      primaryColor: "Primärfarbe",
      widgetPosition: "Widget-Position",
      positions: {
        bottomRight: "Unten rechts",
        bottomLeft: "Unten links",
        topRight: "Oben rechts",
        topLeft: "Oben links"
      },
      theme: "Design",
      themes: {
        light: "Hell",
        dark: "Dunkel",
        system: "Systemstandard"
      },
      completeSetup: "Setup abschließen"
    },
    fr: {
      step: "Étape",
      of: "sur",
      createAccount: "Créer votre compte",
      emailAddress: "Adresse e-mail",
      password: "Mot de passe",
      websiteUrl: "URL du site web",
      companyName: "Nom de l'entreprise",
      continue: "Continuer",
      configureAI: "Configurer l'assistant IA",
      assistantTone: "Ton de l'assistant",
      tones: {
        professional: "Professionnel",
        friendly: "Amical",
        casual: "Décontracté"
      },
      primaryLanguage: "Langue principale",
      languages: {
        en: "Anglais",
        de: "Allemand",
        fr: "Français",
        bg: "Bulgare",
        ro: "Roumain"
      },
      knowledgeBase: "Base de connaissances",
      knowledgeBaseOptions: {
        auto: "Génération automatique depuis le site web",
        custom: "Télécharger des documents personnalisés",
        hybrid: "Hybride (Auto + Personnalisé)"
      },
      customizeAppearance: "Personnaliser l'apparence",
      primaryColor: "Couleur principale",
      widgetPosition: "Position du widget",
      positions: {
        bottomRight: "En bas à droite",
        bottomLeft: "En bas à gauche",
        topRight: "En haut à droite",
        topLeft: "En haut à gauche"
      },
      theme: "Thème",
      themes: {
        light: "Clair",
        dark: "Sombre",
        system: "Système par défaut"
      },
      completeSetup: "Terminer la configuration"
    },
    bg: {
      step: "Стъпка",
      of: "от",
      createAccount: "Създайте акаунт",
      emailAddress: "Имейл адрес",
      password: "Парола",
      websiteUrl: "URL на уебсайта",
      companyName: "Име на компанията",
      continue: "Продължи",
      configureAI: "Конфигуриране на AI асистент",
      assistantTone: "Тон на асистента",
      tones: {
        professional: "Професионален",
        friendly: "Приятелски",
        casual: "Неформален"
      },
      primaryLanguage: "Основен език",
      languages: {
        en: "Английски",
        de: "Немски",
        fr: "Френски",
        bg: "Български",
        ro: "Румънски"
      },
      knowledgeBase: "База знания",
      knowledgeBaseOptions: {
        auto: "Автоматично генериране от уебсайта",
        custom: "Качване на персонализирани документи",
        hybrid: "Хибрид (Авто + Персонализиран)"
      },
      customizeAppearance: "Персонализиране на изгледа",
      primaryColor: "Основен цвят",
      widgetPosition: "Позиция на уиджета",
      positions: {
        bottomRight: "Долу вдясно",
        bottomLeft: "Долу вляво",
        topRight: "Горе вдясно",
        topLeft: "Горе вляво"
      },
      theme: "Тема",
      themes: {
        light: "Светла",
        dark: "Тъмна",
        system: "Системна"
      },
      completeSetup: "Завърши настройката"
    },
    ro: {
      step: "Pasul",
      of: "din",
      createAccount: "Creează cont",
      emailAddress: "Adresă de email",
      password: "Parolă",
      websiteUrl: "URL website",
      companyName: "Numele companiei",
      continue: "Continuă",
      configureAI: "Configurează asistentul AI",
      assistantTone: "Tonul asistentului",
      tones: {
        professional: "Profesional",
        friendly: "Prietenos",
        casual: "Casual"
      },
      primaryLanguage: "Limba principală",
      languages: {
        en: "Engleză",
        de: "Germană",
        fr: "Franceză",
        bg: "Bulgară",
        ro: "Română"
      },
      knowledgeBase: "Bază de cunoștințe",
      knowledgeBaseOptions: {
        auto: "Generare automată din website",
        custom: "Încarcă documente personalizate",
        hybrid: "Hibrid (Auto + Personalizat)"
      },
      customizeAppearance: "Personalizează aspectul",
      primaryColor: "Culoarea primară",
      widgetPosition: "Poziția widget-ului",
      positions: {
        bottomRight: "Dreapta jos",
        bottomLeft: "Stânga jos",
        topRight: "Dreapta sus",
        topLeft: "Stânga sus"
      },
      theme: "Temă",
      themes: {
        light: "Luminoasă",
        dark: "Întunecată",
        system: "Implicit sistem"
      },
      completeSetup: "Finalizează configurarea"
    }
  };